<div class="login_flex">
    <div class="iltt_colone">
        <div class="log_colone">
            <h1 class="log_head"></h1>
        </div>
        <div class="log_colone_topper">
            <figure class="mb-0 loginsri">
                <img src="../../assets/image/sri_logo.png" alt="loginimg" class="loginimg">
            </figure>
        </div>
        <div class="aced_comp">
            <p class="log_acedstudents">Sri Chaitanya Parent App</p>
        </div>
        <div class="log_colone_topper">
            <figure class="mb-0 ">
                <img src="../../../assets/image/MicrosoftTeams-image (1).png" alt="loginimg" class="">
            </figure>
        </div>
    </div>
    <div class="iltt_coltwo">
        <div class="row">
            <div class="col-md-12">
                <div class="log_card">
                    <form class="form-horizontal" [formGroup]="parentform">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="mis_sign_achd"><span>
                                        <img src="../../../assets/image/favicon.ico" alt="sclogo" class="sclogo"></span>
                                    Sign in to your account
                                </h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="email" class="form-control" id="inputEmail3"
                                        placeholder="Admission number" formControlName="admissionNumber" maxlength="9">
                                    <i class="fa fa-user"></i>
                                    <span
                                        *ngIf="isFormInvalid&& parentform.controls['admissionNumber'].hasError('required')"
                                        style="color: rgb(255, 0, 0);">* Admission number must be required</span>
                                    <small style="color: rgb(255, 0, 0);"
                                        *ngIf="parentform.get('admissionNumber')?.touched && parentform.get('admissionNumber')?.hasError('invalidNumber')">Numbers
                                        accepted only!</small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="text" class="form-control" id="inputEmail3" placeholder="Mobile number"
                                        formControlName="mobileNo" maxlength="10">
                                    <i class="fa fa-mobile"></i>
                                    <span *ngIf="isFormInvalid&& parentform.controls['mobileNo'].hasError('required')"
                                        style="color: rgb(255, 0, 0);">* Mobile number must be required</span>
                                    <small style="color: rgb(255, 0, 0);"
                                        *ngIf="parentform.get('mobileNo')?.touched && parentform.get('mobileNo')?.hasError('invalidNumber')">Numbers
                                        accepted only!</small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input [matDatepicker]="picker" placeholder="DD-MMM-YYYY"
                                        class="form-control datesize" formControlName="Date" readonly>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <i class="fa fa-calendar"></i>
                                    <span *ngIf="isFormInvalid&& parentform.controls['Date'].hasError('required')"
                                        style="color: rgb(255, 0, 0);">* Date of Birth must be required</span>
                                    <div *ngIf="errorDescription">
                                        <small class="text-danger"
                                            style="text-align: right; width: 85%;">*{{errorDescription}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" class="mis_loginbtn" (click)="submit()">Login</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ================== loader ==================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>